module.exports = __webpack_public_path__ + "static/media/ladditionMenu.4267101d.png";